module.exports = __webpack_public_path__ + "static/media/uncomfortable.ef78e577.png";